import * as React from "react";
const SvgFilterClear = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 1L5 5M5 5L1 1M5 5L1 9M5 5L9 9", stroke: "black", strokeWidth: 1.4, strokeLinecap: "round" }));
export default SvgFilterClear;
